import { render, staticRenderFns } from "./ProjectManagementConsulting.vue?vue&type=template&id=1344f8c2&scoped=true&"
import script from "./ProjectManagementConsulting.vue?vue&type=script&lang=js&"
export * from "./ProjectManagementConsulting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1344f8c2",
  null
  
)

export default component.exports